import * as React from "react";
import type { SVGProps } from "react";
export const SvgLolXIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="m8.74 12.21 3.968 5.29h5.833l-6.548-8.731L17.442 2.5h-2.208L10.97 7.405 7.29 2.5H1.458l6.26 8.345L1.931 17.5h2.209l4.599-5.29Zm4.801 3.623L4.791 4.167h1.667l8.75 11.666h-1.667Z" />
  </svg>
);
